export const aiCodeReviewGuide = {
  "title": "AI code review without overengineering",
  "slug": "ai-code-review-without-overengineering",
  "date": "2026-10-26",
  "description": "Weigh AI code review findings against evidence and maintenance cost. Includes a stale-response code example and a focused review prompt."
} as const;
